export const MAX_ZOOM_FOR_CLUSTER = 15;
